<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body table-responsive">
                        <div class="row d-flex align-items-center">
                            <div class="col-lg-auto">
                                <h5 class="card-title m-0">
                                    <i class='bx bx-transfer me-1 text-primary'></i>Transactions
                                </h5>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-auto">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary" id="search"
                                        ngbTooltip="Filter by From date." placement="top" container="body">
                                        <i class="bx bx-calendar-week"></i>
                                    </span>
                                    <input type="date" class="form-control border-start-0" id="search"
                                        placeholder="From date..." autocomplete="off" [(ngModel)]="fromDate">
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-auto ps-1">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary" id="search"
                                        ngbTooltip="Filter by To date." placement="top" container="body">
                                        <i class="bx bx-calendar-week"></i>
                                    </span>
                                    <input type="date" class="form-control border-start-0" id="search"
                                        placeholder="To date..." autocomplete="off" [(ngModel)]="toDate"
                                        [min]="fromDate">
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-2 me-auto ps-1">
                                <div class="input-group">
                                    <button type="button" ngbTooltip="Fetch Records." placement="top" container="body"
                                        class=" btn btn-secondary btn-sm " style="font-size: 18px;"
                                        (click)="onTransactionChange()">
                                        <i class="bx bx-search-alt-2 ri-lg align-middle me-0"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-auto ms-auto">
                                <button type="button" class="btn btn-secondary" (click)="upsertTransaction()"
                                    [ngClass]="{'not-allowed':!privilege.canEdit}"
                                    [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): setup.transaction.edit' : ''">
                                    <i class="bx bx-plus"></i> Apply Transaction
                                </button>
                            </div>
                        </div>
                        <table class="table" id="table">
                            <thead id="table-thead">
                                <tr class="bg-light">
                                    <th scope="col" width="70">#</th>
                                    <th scope="col" width="200">Date</th>
                                    <th scope="col" width="300">Ref Id</th>
                                    <th scope="col" width="300">Particular</th>
                                    <th scope="col" width="160" class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let transaction of transactions; let i=index">
                                    <td>{{i+1}}.</td>
                                    <td>{{transaction.date| date:'MMM dd, yyyy'}}</td>
                                    <td>{{transaction.refId}}</td>
                                    <td>{{transaction.particular}}</td>
                                    <td class="actions">
                                        <i class="bx bx-edit alert-primary"
                                            [ngClass]="{'no-event':transaction?.isDeleteInProgress,'not-allowed':!privilege.canEdit}"
                                            [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): setup.transaction.edit' : 'Update Transaction'"
                                            (click)="upsertTransaction(transaction)"></i>
                                        <i *ngIf="!transaction?.isDeleteInProgress" class="bx bx-trash alert-secondary"
                                            [ngClass]="{'not-allowed':!privilege.canDelete}"
                                            [ngbTooltip]="!privilege.canDelete ? 'You need permissions for this action. Required permission(s): setup.transaction.delete' : 'Delete Transaction'"
                                            (click)="deleteTransaction(transaction,i)"></i>
                                        <div *ngIf="transaction?.isDeleteInProgress" role="status"
                                            class="spinner-border spinner-border-sm text-danger">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr class="no-data">
                                    <ng-container *ngIf="isLoading; else noDataTemplate">
                                        <td colspan="8">Fetching data, please wait...</td>
                                    </ng-container>
                                    <ng-template #noDataTemplate>
                                        <ng-container
                                            *ngIf="transactions && transactions.length < 1; else noSearchResults">
                                            <td colspan="8">No transactions were found.</td>
                                        </ng-container>
                                        <ng-template #noSearchResults>
                                            <td colspan="8"
                                                *ngIf="searchKeyword && (transactions | search : 'name' : searchKeyword).length == 0">
                                                No transaction were found for the search results.
                                            </td>
                                        </ng-template>
                                    </ng-template>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>